import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import classnames from 'classnames2';
import headerStyles from './Header.scss';

var chooseHtmlElement = function chooseHtmlElement(as, variant) {
  if (as) {
    return as;
  } else if (variant === 'hero') {
    return 'h1';
  } else {
    return variant;
  }
};

var mapElementToAriaLevel = function mapElementToAriaLevel(element) {
  switch (element) {
    case 'span':
      return null;

    case 'h2':
      return 2;

    case 'h3':
      return 3;

    case 'h4':
      return 4;

    case 'h5':
      return 5;

    default:
    case 'h1':
      return 1;
  }
};

export var Header = function Header(_ref) {
  var _classnames;

  var as = _ref.as,
      children = _ref.children,
      className = _ref.className,
      dataTest = _ref.dataTest,
      id = _ref.id,
      roll = _ref.roll,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
      rest = _objectWithoutProperties(_ref, ["as", "children", "className", "dataTest", "id", "roll", "variant"]);

  var ariaRoll = roll === 'presentation' ? 'presentation' : 'heading';
  var HtmlElement = chooseHtmlElement(as, variant);
  var ariaLevel = mapElementToAriaLevel(HtmlElement);
  var headerClasses = classnames(headerStyles.header, className, (_classnames = {}, _defineProperty(_classnames, headerStyles.hero, variant === 'hero'), _defineProperty(_classnames, headerStyles.header1, variant === 'h1'), _defineProperty(_classnames, headerStyles.header2, variant === 'h2'), _defineProperty(_classnames, headerStyles.header3, variant === 'h3'), _defineProperty(_classnames, headerStyles.header4, variant === 'h4'), _defineProperty(_classnames, headerStyles.header5, variant === 'h5'), _classnames));
  return React.createElement(HtmlElement, Object.assign({
    className: headerClasses,
    "data-test": dataTest,
    id: id,
    role: ariaRoll,
    "aria-level": ariaLevel
  }, rest), children);
};